
// 检测是否有权限
// 使用Vue.directive声明自定义指令btn-key
// // 检测传入的元素key是否可以显示
const checkKey = (key) => {
  // 获取权限数组
  // let permissionData = sessionStorage.getItem("permissionData") ? sessionStorage.getItem("permissionData") : [] ;
  let permissionData = ["1","2"]
  //如果传入的元素key不在权限数组里，则不可显示
  let index = permissionData.indexOf(key)
  if(index > -1) {
    return true;
  }else{
    return false;
  }
}
export default {
  /**
   * inserted：被绑定元素插入父节点时调用
   * el：指令所绑定的元素，可以用来直接操作 DOM
   * binding.value：指令的绑定值，例如：v-my-directive="1 + 1" 中，绑定值为 2。
   */
  mounted(el, binding, vnode, prevVnode){
    console.log("buttonPermissions")
    console.log(binding)
    let buttonKey = binding.value;
    // 代表某个元素需要通过权限验证
    if(buttonKey){
      let key = checkKey(buttonKey)
      if(!key){//没有权限
        el.parentNode && el.parentNode.removeChild(el)
      }
    }else{
      throw new Error('缺少唯一指令')
    }
  },


}
